
    import './styles.scoped.css';
    export default {
  "calendar": "_calendar_7p2tj_3",
  "awsui-motion-fade-in-0": "_awsui-motion-fade-in-0_7p2tj_1",
  "root": "_root_7p2tj_26",
  "date-picker-container": "_date-picker-container_7p2tj_36",
  "calendar-inner": "_calendar-inner_7p2tj_45",
  "calendar-header": "_calendar-header_7p2tj_48",
  "calendar-header-month": "_calendar-header-month_7p2tj_53",
  "calendar-next-month-btn": "_calendar-next-month-btn_7p2tj_59",
  "calendar-prev-month-btn": "_calendar-prev-month-btn_7p2tj_62",
  "calendar-day-names": "_calendar-day-names_7p2tj_65",
  "calendar-day-name": "_calendar-day-name_7p2tj_65",
  "calendar-dates": "_calendar-dates_7p2tj_79",
  "calendar-week": "_calendar-week_7p2tj_82",
  "calendar-day": "_calendar-day_7p2tj_65",
  "calendar-day-in-last-week": "_calendar-day-in-last-week_7p2tj_100",
  "calendar-day-focusable": "_calendar-day-focusable_7p2tj_103",
  "calendar-day-enabled": "_calendar-day-enabled_7p2tj_106",
  "calendar-day-current-month": "_calendar-day-current-month_7p2tj_110",
  "calendar-day-selected": "_calendar-day-selected_7p2tj_117",
  "calendar-day-today": "_calendar-day-today_7p2tj_120"
};
  